import { Text, HStack, Heading, PinInput, PinInputField, Flex, Button, Box } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

interface Props {
	otp: string;
	setOtp: (otp: string) => void;
	setShowOtpUi: (showOtpUi: boolean) => void;
	phoneNumber: string;
	resendOtp: () => void;
}

interface OTP {
	code: string;
}

const phoneRegex = /^[6-9]\d{9}$/;

const OtpPage = ({ phoneNumber, otp, setOtp, setShowOtpUi, resendOtp }: Props) => {
	const [countdown, setCountdown] = useState<number | null>(30);

	useEffect(() => {
		if ('credentials' in navigator) {
			const input: HTMLInputElement | null = document.querySelector('input[autocomplete="one-time-code"]');
			console.log('input:', input);
			if (!input) return;
			const ac = new AbortController();
			console.log('ac:', ac);
			const form: HTMLFormElement | null = input.closest('form');
			console.log('form:', form);
			if (form) {
				form.addEventListener('submit', e => {
					ac.abort();
				});
			}
			console.log('navigator:', navigator, navigator.credentials);
			navigator.credentials
				.get({
					// @ts-ignore
					otp: { transport: ['sms'] },
					signal: ac.signal,
				})
				// @ts-ignore
				.then((otp: OTP) => {
					console.log('otp:', otp);
					setOtp(otp.code);
					if (form) form.submit();
				})
				.catch(err => {
					console.log(err);
					ac.abort();
				});
		}
	}, []);

	const startCountdown = () => {
		setCountdown(30);
	};

	useEffect(() => {
		let intervalId: NodeJS.Timeout;

		if (countdown !== null && countdown > 0) {
			intervalId = setInterval(() => {
				// @ts-ignore
				setCountdown(prevCountdown => prevCountdown - 1);
			}, 1000);
		}

		// Clear the interval when the component unmounts
		return () => clearInterval(intervalId);
	}, [countdown]);

	const handleResendClick = () => {
		startCountdown();
		resendOtp();
	};

	// Start the countdown when the component loads
	useEffect(() => {
		startCountdown();
	}, []);

	return (
		<Flex flexDirection="column" gap="16px" maxW={{ md: '358px' }} mx="auto">
			<Box w="100%" textAlign="center">
				<Heading as="h3">Verify {phoneRegex.test(phoneNumber) ? 'Number' : 'Email'}</Heading>
			</Box>
			<Text textStyle="body2-md">
				Enter OTP sent to {phoneNumber}{' '}
				<Text
					cursor="pointer"
					color={'#4358F6'}
					as="span"
					textDecoration={'underline'}
					onClick={() => {
						setShowOtpUi && setShowOtpUi(false);
					}}
				>
					Edit
				</Text>
			</Text>
			<HStack>
				<PinInput autoFocus={true} size="lg" placeholder="" value={otp} onChange={value => setOtp(value)}>
					<PinInputField bg="#F3F3F3" w="50px" h="50px" />
					<PinInputField bg="#F3F3F3" w="50px" h="50px" />
					<PinInputField bg="#F3F3F3" w="50px" h="50px" />
					<PinInputField bg="#F3F3F3" w="50px" h="50px" />
					<PinInputField bg="#F3F3F3" w="50px" h="50px" />
					<PinInputField bg="#F3F3F3" w="50px" h="50px" />
				</PinInput>
				{/* @ts-ignore */}
				<input type="text" style={{ display: 'none' }} autoComplete="one-time-code" inputMode="numeric" />
			</HStack>
			<Box>
				{countdown != null && countdown > 0 ? (
					<Text fontSize="14px">Resend OTP in {countdown} seconds</Text>
				) : (
					<Text fontSize="14px" color="#4358F6" cursor="pointer" onClick={handleResendClick}>
						Resend OTP
					</Text>
				)}
			</Box>
		</Flex>
	);
};

export default OtpPage;
